/**
 * Content schedule: show scheduled content between global publish and end times.
 * Config is read from window.theme.settings.contentSchedule.
 */
(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function getConfig() {
    var settings = window.theme && window.theme.settings;
    return (settings && settings.contentSchedule) || {};
  }

  function nowString(tz) {
    var d = new Date();

    if (!tz) {
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + 'T' + pad(d.getHours()) + ':' + pad(d.getMinutes());
    }

    try {
      var formatter = new Intl.DateTimeFormat('en-CA', {
        timeZone: tz,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        hourCycle: 'h23'
      });
      var parts = formatter.formatToParts(d);
      var getPart = function (type) {
        var p = parts.find(function (x) {
          return x.type === type;
        });
        return p ? p.value : '';
      };
      var y = getPart('year');
      var mo = getPart('month');
      var day = getPart('day');
      var h = getPart('hour');
      var min = getPart('minute');

      if (y && mo && day && h !== '' && min !== '') {
        return y + '-' + pad(parseInt(mo, 10)) + '-' + pad(parseInt(day, 10)) + 'T' + pad(parseInt(h, 10)) + ':' + pad(parseInt(min, 10));
      }
    } catch (_) {}

    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + 'T' + pad(d.getHours()) + ':' + pad(d.getMinutes());
  }

  function dateTimeStr(dateStr, timeStr) {
    if (!dateStr || !timeStr) return null;
    var t = timeStr.trim().match(/^(\d{1,2}):(\d{1,2})/);
    if (!t) return null;
    return dateStr.trim() + 'T' + pad(parseInt(t[1], 10)) + ':' + pad(parseInt(t[2], 10));
  }

  function dateTimeMsLocal(dateTimeString) {
    var m = dateTimeString.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
    if (!m) return null;
    return new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10), parseInt(m[4], 10), parseInt(m[5], 10)).getTime();
  }

  function notifyChange() {
    window.dispatchEvent(new Event('resize'));
    document.dispatchEvent(new CustomEvent('content-schedule:change', { bubbles: true }));
  }

  function isScheduledActive(config) {
    if (config.preview) return true;

    var timezone = (config.timezone || '').trim();
    var publishStr = dateTimeStr(config.publishDate, config.publishTime);
    if (!publishStr) return false;

    var now = nowString(timezone);
    var endStr = dateTimeStr(config.endDate, config.endTime);

    if (now < publishStr) return false;
    if (endStr && now >= endStr) return false;
    return true;
  }

  function updateSlideLinks(config) {
    var scheduled = isScheduledActive(config);
    document.querySelectorAll('[data-schedule-slide-link]').forEach(function (el) {
      var href = scheduled ? el.dataset.scheduleScheduledHref : el.dataset.scheduleDefaultHref;
      if (href) el.setAttribute('href', href);
    });
  }

  function apply(wrapper, config) {
    wrapper.classList.remove('content-schedule--before', 'content-schedule--scheduled', 'content-schedule--default');

    if (config.preview) {
      wrapper.classList.add('content-schedule--scheduled');
      return;
    }

    var timezone = (config.timezone || '').trim();
    var publishStr = dateTimeStr(config.publishDate, config.publishTime);

    if (!publishStr) {
      wrapper.classList.add('content-schedule--default');
      return;
    }

    var now = nowString(timezone);
    var endStr = dateTimeStr(config.endDate, config.endTime);

    if (now < publishStr) {
      wrapper.classList.add('content-schedule--default');
      return;
    }

    if (endStr && now >= endStr) {
      wrapper.classList.add('content-schedule--default');
      return;
    }

    wrapper.classList.add('content-schedule--scheduled');
  }

  function checkPublish(wrapper, publishStr, tz, config) {
    if (!tz) {
      var publishMs = dateTimeMsLocal(publishStr);
      if (publishMs != null) {
        var delay = publishMs - Date.now();
        if (delay > 0 && delay < 86400000) {
          setTimeout(function () {
            apply(wrapper, config);
            run();
          }, delay);
          return;
        }
      }
    }

    function tick() {
      if (nowString(tz) >= publishStr) {
        apply(wrapper, config);
        run();
      } else {
        setTimeout(tick, 10000);
      }
    }

    setTimeout(tick, 10000);
  }

  function checkEnd(wrapper, endStr, tz, config) {
    if (!tz) {
      var endMs = dateTimeMsLocal(endStr);
      if (endMs != null) {
        var delay = endMs - Date.now();
        if (delay > 0 && delay < 86400000) {
          setTimeout(function () {
            apply(wrapper, config);
            run();
          }, delay);
          return;
        }
      }
    }

    function tick() {
      if (nowString(tz) >= endStr) {
        apply(wrapper, config);
        run();
      } else {
        setTimeout(tick, 10000);
      }
    }

    setTimeout(tick, 10000);
  }

  function run() {
    var config = getConfig();
    if (!config.enabled) return;

    var wrappers = document.querySelectorAll('[data-content-schedule-wrapper]');
    wrappers.forEach(function (wrapper) {
      apply(wrapper, config);

      if (config.preview) return;

      var tz = (config.timezone || '').trim();
      var publishStr = dateTimeStr(config.publishDate, config.publishTime);
      var endStr = dateTimeStr(config.endDate, config.endTime);
      var now = nowString(tz);

      if (publishStr && now < publishStr) checkPublish(wrapper, publishStr, tz, config);
      else if (endStr && now < endStr) checkEnd(wrapper, endStr, tz, config);
    });

    notifyChange();
    updateSlideLinks(config);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  document.addEventListener('shopify:section:load', run);
})();
